import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private http: HttpClient) { }

  GetRecord(fullname: String): Observable<Array<any>>{
    return this.http.get(environment.BaseUrl + "Daro/Role?fullname="+fullname).pipe(
      map(data=>{
        return data as Array<any>
      })
    )
  }


  addeditRole(model: General_Interface,
    ListMenu: Array<number>,
    ListRoleUser: Array<string>,
    DeviceBehfaRole: Array<number>,
    TicketCategory: Array<number>,
    DataEntity1: Array<number>,
    ListDeviceBehfaRepair: Array<number>): Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var modelRole = {
      id:model.id,
      title: model.title,
      username: '',
      del:false
    }

    var body = {
      model: modelRole,
      ListMenu: ListMenu,
      ListRoleUser: ListRoleUser,
      TicketCategory: TicketCategory,
      ListDeviceBehfaRepair:ListDeviceBehfaRepair,
      DeviceBehfaRole: DeviceBehfaRole,
      DataEntity:DataEntity1,
    }


    return this.http.post(environment.BaseUrl + "Daro/Role/AddEdit",body,{headers}).pipe(
      map(data=>{

        return data as General_Interface
      })
    )

  }


  Delete(id: number): Observable<boolean>{
    return this.http.get(environment.BaseUrl + "Daro/Role/Delete?id="+id
      ).pipe(
      map(data=>{
        return data as boolean
      })
    )
  }


  //#region Access

  GetNav(id:number,customer:boolean):Observable<Array<Nav_Interface>>{
    return this.http.get(environment.BaseUrl+ "Daro/Role/GetNav?id="+id+"&customer="+customer).pipe(
      map(data=>{
        return data as Array<Nav_Interface>
      })
    )
  }

  GetLetterRole(id: number,): Observable<Array<Nav_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Role/GetLetterRole?id=" + id).pipe(
        map(data => {
          return data as Array<Nav_Interface>
        })
      )
  }
  
  GetTicketCategoryUser(id:number,):Observable<Array<Nav_Interface>>{
    return this.http.get(environment.BaseUrl
      + "Daro/Role/GetTicketCategoryUser?id="+id).pipe(
      map(data=>{
        return data as Array<Nav_Interface>
      })
    )
  }

  GetDeviceBehfaRepairRole(id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Role/GetDeviceBehfaRepairRole?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetDeviceBehfaRole(
    id: number,): Observable<Array<Nav_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Role/GetDeviceBehfaRole?id=" + id).pipe(
        map(data => {
          return data as Array<Nav_Interface>
        })
      )
  }

  GetDataEntity(id:number,):Observable<Array<Nav_Interface>>{
    return this.http.get(environment.BaseUrl
      + "Daro/Role/GetDataEntity?id="+id).pipe(
      map(data=>{
        return data as Array<Nav_Interface>
      })
    )
  }

  //#endregion


  //#region Person

  GetPerson(id: number): Observable<Array<Persone_List_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Role/GetPerson?id="+id).pipe(
      map(data=>{
        return data as Array<Persone_List_Interface>
      })
    )
  }

  
  DeletePerson(id: number): Observable<boolean>{
    return this.http.get(environment.BaseUrl + "Daro/Role/DeletePerson?id="+id
      ).pipe(
      map(data=>{
        return data as boolean
      })
    )
  }

  AddPerson(role_id: number,
    person_id: number):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id:0,
      person_id:person_id,
      role_id:role_id,
      Token: ''
    }
    return this.http.post(environment.BaseUrl + "Daro/Role/AddPerson",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
    )

  }

  //#endregion


}
